export default __webpack_public_path__ + "static/N0296-5a655285832cb23134dde8164b32ac71.png";